import instance from "../../services/api";

export const getReportDs = params => {
  return instance(true)
    .post(`/partner/report_ds/`, params)
    .then((res = {}) => {
      return res?.data;
    });
};
